import React from 'react';
import { Camera, Code, Rocket, Target } from 'lucide-react';
import { mockData } from '../data/mock';

const About = () => {
  const { about } = mockData;

  const highlights = [
    {
      icon: Code,
      title: "Développement Web",
      description: "Sites rapides, clairs et pensés pour convertir"
    },
    {
      icon: Rocket,
      title: "E-commerce",
      description: "Boutiques optimisées pour vendre et grandir"
    },
    {
      icon: Camera,
      title: "Production Vidéo",
      description: "Images fortes pour valoriser votre activité"
    },
    {
      icon: Target,
      title: "Vision Business",
      description: "Des livrables alignés sur vos objectifs"
    }
  ];

  return (
    <section
      id="about"
      className="py-20"
      style={{
        backgroundColor: '#FFFFFF',
        backgroundImage: 'radial-gradient(rgba(15, 23, 42, 0.05) 1px, transparent 1px)',
        backgroundSize: '4px 4px'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Column - Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold mb-6 tracking-tight" style={{ color: '#1e3a8a' }}>
                {about.title}
              </h2>
              <div className="w-16 h-1 rounded-full mb-8" style={{ backgroundColor: '#f97316' }}></div>
            </div>

            <div className="space-y-6">
              <p className="text-xl text-gray-700 leading-relaxed">
                {about.description}
              </p>
              
              <p className="text-lg text-gray-600 leading-relaxed">
                {about.story}
              </p>
            </div>

            {/* Quote */}
            <blockquote className="border-l-4 pl-6 py-4 bg-gray-50 rounded-r-lg" style={{ borderLeftColor: '#f97316' }}>
              <p className="text-xl font-medium text-gray-800 italic">
                "{about.quote}"
              </p>
              <cite className="text-gray-600 text-sm mt-2 block">— {about.name}</cite>
            </blockquote>

            {/* Highlights Grid */}
            <div className="grid sm:grid-cols-2 gap-6 pt-8">
              {highlights.map((highlight, index) => (
                <div key={index} className="group">
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <div 
                        className="w-12 h-12 rounded-lg flex items-center justify-center transition-colors duration-200"
                        style={{ backgroundColor: '#1e3a8a' }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#1e40af'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#1e3a8a'}
                      >
                        <highlight.icon className="h-6 w-6 text-white" />
                      </div>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-2">
                        {highlight.title}
                      </h3>
                      <p className="text-gray-600 text-sm">
                        {highlight.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src={about.image}
                alt="Christopher Clercq - Développeur Web & Vidéaste"
                className="w-full h-[600px] object-cover transform hover:scale-105 transition-transform duration-700"
              />
              
              {/* Overlay with gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              
              {/* Badge */}
              <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm rounded-lg px-4 py-2 shadow-lg">
                <p className="text-sm font-medium text-gray-900">Christopher Clercq</p>
                <p className="text-xs text-gray-600">Développeur Web & Vidéaste</p>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full opacity-10" style={{ backgroundColor: '#f97316' }}></div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-gray-900 rounded-full opacity-5"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
